/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.email-supplier-toolbar[_ngcontent-%COMP%]{background-color:#fff;padding:15px 0 35px 10px}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvc2xpcHJlc2lzdGFudC9zbGlwcmVzaXN0YW50L2NsaWVudC9zcmMvYXBwL2VtYWlsLXN1cHBsaWVyL2VtYWlsLXN1cHBsaWVyLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2hvbWUvcnVubmVyL3dvcmsvc2xpcHJlc2lzdGFudC9zbGlwcmVzaXN0YW50L2NsaWVudC9zcmMvYXBwL2VtYWlsLXN1cHBsaWVyL2VtYWlsLXN1cHBsaWVyLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/$$_gendir/app/email-supplier/email-supplier.component.scss.shim.ngstyle.ts